import logoUrl from '../assets/mtc-logo-horizontal.png';

type Props = {
  /** Pixel height of the rendered logo. Width auto-scales to preserve the aspect ratio. */
  size?: number;
  /**
   * `true` when the logo sits on a dark background (footer). We pad it inside
   * a cream-tinted card so the colored wordmark stays readable instead of
   * blending into the dark surface.
   */
  mono?: boolean;
};

/**
 * Brand mark — single horizontal PNG containing both the MTC icon and the
 * "MOROCCAN TRAINING CENTER" wordmark. The old text-spans were dropped now
 * that everything is baked into one image.
 */
export function MTCLogo({ size = 44, mono = false }: Props) {
  return (
    <div
      className="mtc-logo"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        // On the dark footer, the colored wordmark would disappear against the
        // background — keep a cream pill behind it so the brand still reads.
        background: mono ? '#FAF6EE' : 'transparent',
        padding: mono ? '6px 12px' : 0,
        borderRadius: mono ? 8 : 0,
      }}
    >
      <img
        src={logoUrl}
        alt="Moroccan Training Center"
        height={size}
        style={{
          height: `${size}px`,
          width: 'auto',
          display: 'block',
          objectFit: 'contain',
        }}
      />
    </div>
  );
}
